import Vue from 'vue'
import DateUtils from '@/libraries/DateUtils'
import _ from 'lodash'

Vue.filter('formatDateDDMMYYYY', function (value) {
  let dateUtils = new DateUtils(value)
  return dateUtils.formatDateDDMMYYYY()
});

Vue.filter('formatDateHHII', function (value) {
  let dateUtils = new DateUtils(value)
  return dateUtils.formatDateHHII()
});

Vue.filter('truncate', function (value, length, concat) {
  
  if (_.isNil(value) || _.isEmpty(value)) {
    return value
  }

  if (value.length <= length) {
    return value
  }
  
  return value.slice(0, length).concat(concat)

});

Vue.filter('formatFloat', function (value) {

  if (!_.isNumber(value)) {
    return value
  }
  
  return value.toLocaleString('es-ES', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2, 
    style: 'currency', 
    currency: 'EUR'
  })

});

Vue.filter('boolToString', function (value) {

  return value ? 'Sí' : 'No'

});